import {
  Button,
  Card,
  Table,
  Input,
  Row,
  Col,
  DatePicker,
} from "antd";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import Plus from "../../assets/images/plus.svg";
import apiPath from "../../constants/apiPath";
import { AppStateContext } from "../../context/AppContext";
import { Severty, ShowToast } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import useRequest from "../../hooks/useRequest";
import { UndoOutlined } from "@ant-design/icons";

function Index() {
  const heading = "Subscription Management";
  const { setPageHeading } = useContext(AppStateContext);
  const Search = Input.Search;

  const api = {
    list: apiPath.listSubscriptions,
  };

  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState();
  const [showDelete, setShowDelete] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const debouncedSearchText = useDebounce(searchText, 300);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [rowFilter, setRowFilter] = useState({});

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: 10 });
  };

  const onDelete = (id) => {
    request({
      url: api.delete + "/" + id,
      method: "DELETE",
      onSuccess: (data) => {
        setLoading(false);
        setRefresh((prev) => !prev);
        ShowToast(data.message, Severty.SUCCESS);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const columns = [
    {
      title: "Transaction Id",
      dataIndex: "transaction_id",
      key: "transaction_id",
      render: (_, { transaction_id }) => {
        return transaction_id ? `#${transaction_id}` : "-";
      },
    },
    {
      title: "Purchased By",
      render: (_, { user_id }) => {
        return user_id?.name ? user_id?.name : "-";
      },
    },
    {
      title: "amount",
      dataIndex: "amount",
      key: "amount",
      render: (_, { amount }) => {
        return amount;
      },
    },
    {
      title: "Slot(s) Purschased",
      dataIndex: "slot",
      key: "slot",
      render: (_, { slot }) => {
        return slot;
      },
    },
    {
      title: "Subscription Date",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("ll");
      },
    },
  ];

  useEffect(() => {
    setLoading(true);
    fetchData({ ...pagination, current: 1 });
  }, [refresh, debouncedSearchText, startDate, endDate]);

  useEffect(() => {
    setPageHeading(heading);
  }, [setPageHeading]);

  const fetchData = (pagination, filters) => {
    request({
      url:
        api.list +
        `?page=${pagination
          ? pagination.current : 1}&pageSize=${pagination
            ? pagination.pageSize : 10}&search=${debouncedSearchText}&start_date=${startDate
              ? startDate : ""}&end_date=${endDate ? endDate : ""}`,
      method: "GET",
      onSuccess: ({ data, total }) => {
        setLoading(false);
        setList(data);
        setPagination((prev) => ({
          ...prev,
          current: pagination.current,
          total: total,
        }));
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (pagination, filters) => {
    fetchData(pagination, filters);
    setRowFilter(filters)
  }

  return (
    <>
      <div className="tabled productCaralogue">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={"Subscription History"}
              extra={
                <>
                  <div className="w-100 text-head_right_cont">
                    {/* <RangePicker disabledDate={(current) => current.isAfter(Date.now())} onChange={handleChangeDate} /> */}
                    <div className="pageHeadingSearch">
                      <Input.Search
                        className="searchInput"
                        placeholder={"Search by Transaction Id, User name"}
                        value={searchText}
                        onChange={onSearch}
                        allowClear
                        title="Search by Transaction Id, User name"
                      />
                    </div>
                    <Button
                      onClick={() => {
                        setSearchText("");

                      }}
                      type="primary"
                      icon={<UndoOutlined />}
                    >
                      Reset
                    </Button>
                  </div>
                </>
              }
            >
              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Index;
